import { PortableText } from '@portabletext/react';
import ptComponents from './pt-components';
import MarkdownParser from './markdown-parser';
import type {
	ArbitraryTypedObject,
	PortableTextBlock,
} from '@portabletext/types';

const RichText = ({ value }: IProps) => {
	if (!value) {
		return null;
	} //If no text is passed return null.

	//This is a safety measure for if a string is passed into RichText instead of an array of blocks.
	//This allows us to just use this component regardless of what type of field we have in sanity.
	if (typeof value === 'string') {
		return <MarkdownParser>{value}</MarkdownParser>;
	}
	return <PortableText value={value} components={ptComponents} />;
};

// Portable Text arrays can contain our custom block types alongside regular text blocks.
// TODO: Can we narrow these types by explicitly creating a type with our actual custom blocks?
export type RichTextValue =
	Array<PortableTextBlock | ArbitraryTypedObject> | string;

interface IProps {
	value: RichTextValue;
}

export default RichText;
